import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Tooltip from 'components/Tooltip';

import Tile from './Tile';
import List from './List';

import {
	Building,
} from './styles';

class Item extends React.Component {
	render() {
		const { t } = this.props;
		const { image, slug } = this.props.building;
		const imageUrl = image && image.conversions ? image.conversions.small : '';
		const DetailComponent = this.props.browsetype === 'tile' ? Tile : List;

		const star = (
			<Tooltip
				tooltip={t('collection/Add to collection')}
				icon="star-full"
				fill={'rgba(0,0,0,0.4)'}
				style={{
					position: 'absolute',
					top: '16px',
					right: '16px',
					zIndex: 1000,
				}}
				onClickHandler={e => {
					e.stopPropagation();
					e.preventDefault();

					this.props.viewBrochuresHandler();
				}}
			/>
		);

		return (
			<Building
				to={`/${this.props.language}/t/building/${slug}/`}
				browsetype={this.props.browsetype}>
				<DetailComponent
					language={this.props.language}
					activeFilters={this.props.activeFilters}
					onlyFree={this.props.onlyFree}
					image={imageUrl}
					building={this.props.building}
					star={star}
				/>
			</Building>
		);
	}
}

Item.propTypes = {
	t: PropTypes.func,
	language: PropTypes.oneOf(['fi', 'en']),
	activeFilters: PropTypes.array,
	onlyFree: PropTypes.bool,
	slug: PropTypes.string,
	building: PropTypes.object,
	brochuresInCollection: PropTypes.bool,
	collectionData: PropTypes.any,
	browsetype: PropTypes.oneOf(['tile', 'list']),
	viewBrochuresHandler: PropTypes.func,
	collectionHandler: PropTypes.func,
}

export default translate('translations')(Item);
